export default __webpack_public_path__ + "static/media/credit-card-payment.d7fef222.svg";